/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClientType {
    Undefined = 0,
    WebRecorder = 3,
    WebPlayer = 5,
    WebViewingStation = 6,
    AudioInputClient = 7,
    AnnouncementSession = 8,
    MasterOfCeremony = 9,
    Examiner = 10,
}
